module.exports = function(src, callback) {
  var img = new Image();
  img.onload = function() {
    callback(true);
  };
  img.onerror = function() {
    callback(false);
  };
  img.src = src;
};



/*****************
 ** WEBPACK FOOTER
 ** ./~/react-retina-image/~/image-exists/index.js
 ** module id = 241
 ** module chunks = 0
 **/